<template>
  <div class="fixed w-full min-h-5 flex items-center text-center text-white opacity-90"
       :style="{ top: topPosition, backgroundColor, zIndex: isModalActive ? 9999 : 30 }">
    <p class="text-center flex-1 py-3" :class="verticalAlignBottom">
      {{ globalError ? errorMessage : successMessage }}
    </p>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"

  export default {
    name: "Toast",
    computed: {
      topPosition() {
        if (this.$route.path === '/order/new') {
          // TODO: mb something better?
          return window.innerWidth < 1024 ? `128px` : '152px'
        } else {
          return 'unset'
        }
      },

      backgroundColor() {
        return this.globalError ? '#E73838' : '#66BB6A';
      },

      errorMessage() {
        return this.globalError
      },

      successMessage() {
        return this.globalSuccess
      },

      ...mapGetters([
        'globalError',
        'globalSuccess',
        'isModalActive'
      ]),

      verticalAlignBottom() {
        if (this.$route.path !== '/auth/sign-in' && this.$route.path !== '/auth/sign-up') {
          return 'mt-auto'
        }
        return ''
      }
    }
  }
</script>
